import _ from 'lodash'
import { BotFlow, DialogSchema } from '@feedyou/schema'
import botFlowJsonSchema from '@feedyou-ai/feedbot-schema/schema/botFlow.json'
import { updateBotProperties } from '../../../actions/bot'
import { FeedbotDispatch } from '../../../store/types'
import { modalsActions } from '../../../store/modals/modalsSlice'
import { isCustomIntegrationServiceEnabledSelector } from '../../../store/modals/selectors'
import { setMissingOriginalPropsWithUndefinedValue } from '../../../lib/setMissingOriginalPropsWithUndefinedValue'

export function save(flow: Partial<BotFlow>): (dispatch: FeedbotDispatch) => void {
  return (dispatch: FeedbotDispatch) => {
    const { mainDialogs = [] } = flow || {}

    const botWithLabeledMainDialogs = {
      ...flow,
      manDialogs: labelMainDialogs(mainDialogs as DialogSchema[])
    }

    dispatch<any>(updateBotProperties({ ...botWithLabeledMainDialogs }))
    dispatch<any>(modalsActions.closeModal())
  }
}

export const labelMainDialogs = (mainDialogs: DialogSchema[]): void => {
  mainDialogs.map((mainDialog: DialogSchema) => ({ ...mainDialog, asMainDialog: true }))
}

export function getFormData(flow: BotFlow, showDialogs?: boolean): Partial<BotFlow> {
  return showDialogs ? flow : _.omit(flow, ['dialogs'])
}

export function getSchema() {
  const flowSchema = _.omit(botFlowJsonSchema, FLOW_SCHEMA_PROPERTIES_TO_OMIT)
  flowSchema.required = _.difference(flowSchema.required, getRequiredPropertiesToOmit())

  // @ts-ignore
  flowSchema.properties.nlp.title = 'NLP settings'
  // @ts-ignore
  flowSchema.properties.nlp.properties.triggers.title = 'Triggers'

  if (isCustomIntegrationServiceEnabledSelector('gibase')) {
    // @ts-ignore
    delete flowSchema?.properties?.integrations?.properties?.gibase
  }

  return flowSchema
}

export const FLOW_SCHEMA_PROPERTIES_TO_OMIT = [
  'properties.mainDialogId',
  'properties.intro.properties.message',
  'properties.intro.properties.button',
  'properties.dialogs',
  'properties.channels',
  'properties.nlp.properties.faq',
  'properties.nlp.properties.allowedDialogs',
  'properties.nlp.properties.excludedDialogs',
  'properties.nlp.properties.excludedStepIds',
  'properties.nlp.properties.models',
  'properties.nlp.properties.general',
  'properties.nlp.properties.otherDialog',
  'properties.nlp.properties.otherButton',
  'properties.nlp.properties.noMatchDialog',
  'properties.nlp.properties.stepNlp',
  'properties.globalStorages',
  'properties.wizardSettings'
] as const

// Removes 'properties.' from the start of the strings
const getRequiredPropertiesToOmit = () =>
  FLOW_SCHEMA_PROPERTIES_TO_OMIT.map(prop => prop.replace(/^properties\_./, ''))

export function nullifyDeletedFlowProperties(params: {
  newFlow: Partial<BotFlow>
  previousFlow: BotFlow
}): Partial<BotFlow> {
  return setMissingOriginalPropsWithUndefinedValue<Partial<BotFlow>>({
    newObject: params.newFlow,
    originalObject: params.previousFlow,
    readonlyKeys: Object.keys(botFlowJsonSchema.properties)
  })
}
